export { default } from "./Embed";
